import React from 'react';

interface Props {
  children?: React.ReactNode;
  onError?: {
    reload?: string | boolean;
    render?: React.ReactNode;
  };
}

interface State {
  hasError: boolean;
}

export default class ErrorBoundary extends React.Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    if (!!this.props?.onError?.reload) {
      if (typeof this.props?.onError?.reload === 'string') {
        window.location.href = this.props?.onError?.reload;
      } else if (this.props?.onError?.reload === true) {
        window.location.reload();
      }
    }
  }

  public render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      if (this.props.onError?.render) {
        return this.props.onError.render;
      }

      return (
        <div style={{ padding: '1em' }}>
          <h1>Something went wrong.</h1>
          <p>
            <a href={window.location.href} onClick={() => window.location.reload()}>
              Refresh{' '}
            </a>
            the page.
          </p>
          <br />
          <p>
            Go back to the <a href="/">home page</a>.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}
